import { cn, Radio, RadioGroup as HeroRadioGroup } from '@heroui/react'

interface RadioOption {
  value: string
  label: string
}

export interface RadioGroupProps {
  name?: string
  options: RadioOption[]
  label?: string
  classNameContainer?: string
  classNames?: {
    label?: string
    base?: string
    control?: string
    [key: string]: string | undefined
  }
  value?: string
  onChange?: (value: string) => void
  onBlur?: () => void
  errorMessage?: string
}

const RadioGroup = ({
  name,
  options,
  label,
  classNameContainer,
  classNames,
  value,
  onChange,
  onBlur,
  errorMessage,
  ...props
}: RadioGroupProps) => {
  return (
    <HeroRadioGroup
      className={cn('custom-radio')}
      errorMessage={errorMessage}
      isInvalid={Boolean(errorMessage)}
      label={label}
      name={name}
      value={value}
      onBlur={onBlur}
      onValueChange={onChange}
      {...props}
    >
      <div className={cn('flex flex-col gap-4', classNameContainer)}>
        {options.map((option: RadioOption) => (
          <Radio
            key={option.value}
            size="sm"
            value={option.value}
            classNames={{
              label: 'text-[#1F242E]',
              base: 'flex gap-3 items-center',
              control: 'bg-[#fff] data-[selected=true]:bg-[#222]',
              ...classNames,
            }}
          >
            {option.label}
          </Radio>
        ))}
      </div>
    </HeroRadioGroup>
  )
}

export default RadioGroup
